<template>
  <b-row>
    <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start mb-1" >
      <span class="text-muted">
        {{paginationString}}</span>
    </b-col>
    <b-col
      cols="12"
      sm="6"
      class="d-flex align-items-center justify-content-center justify-content-sm-end"
    >
      <b-pagination
        v-model="pagination.PageIndex"
        :total-rows="pagination.Count"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <PrevIcon />
        </template>
        <template #next-text>
          <NextIcon />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import PrevIcon from '@/components/icons/PrevIcon.vue';
import NextIcon from '@/components/icons/NextIcon.vue';

export default {
  components: {
    PrevIcon,
    NextIcon,
  },
  data() {
    return {
    };
  },
  computed: {
    pagination() {
      return this.$store.state.sampleDatabase.filterQuery;
    },
    paginationPageEntry() {
      const pageEntryCount = (this.pagination.PageIndex * this.pagination.PageSize);
      if (pageEntryCount > this.pagination.Count) {
        return this.pagination.Count;
      }
      return pageEntryCount;
    },
    start() {
      return this.pagination.PageIndex > 1 ? (this.pagination.PageIndex - 1) * this.pagination.PageSize : '1';
    },

    paginationString() {
      let tPagintaion = this.$tI('Showing count entries');
      tPagintaion = tPagintaion.replace('{start}', this.start);
      tPagintaion = tPagintaion.replace('{end}', this.paginationPageEntry);
      tPagintaion = tPagintaion.replace('{count}', this.pagination.Count);

      return tPagintaion;
    },
  },
  methods: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>
